import { render } from "./bottomNavigation.vue?vue&type=template&id=1dae1a16"
import script from "./bottomNavigation.vue?vue&type=script&lang=js"
export * from "./bottomNavigation.vue?vue&type=script&lang=js"

import "./bottomNavigation.vue?vue&type=style&index=0&id=1dae1a16&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__